import { render, staticRenderFns } from "./malicioushistory.vue?vue&type=template&id=0baf0648&scoped=true"
import script from "./malicioushistory.vue?vue&type=script&lang=js"
export * from "./malicioushistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf0648",
  null
  
)

export default component.exports